import { LoadablePaint } from '@confluence/loadable';

export const LazyImportSpacesPage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ImportSpacesContainer" */ '../src/ImportSpaces/ImportSpacesPage.tsx'
			)
		).ImportSpacesPage,
});
